<!-- MODAL HEADER-->
<div class="row modal-bar">

  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>

  <div class="col-sm-6">

    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>


<form [formGroup]="mainForm" class="form-content">
  <div class="section-wrapper">

    @if (!allowProfileEdit) {
      <div class="row">
        <div class="col-12">
          <t4-page-warning warning="{{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.RELATION-IS-LINKED-TO' | translate}} {{this.customer.PrimaryContact?.SSOProvider}} {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.SINGLE-SIGN-ON' | translate}} {{this.customer.PrimaryContact?.SSOProvider}} {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.BE-MODIFIED' | translate}}"></t4-page-warning>
        </div>
      </div>
    }

    @if (this.customer.PrimaryContact?.AccountingId != null) {
      <div class="row">
        <div class="col-12">
          <t4-page-warning warning="{{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.RELATION-IS-LINKED-TO' | translate}} {{this.customer.PrimaryContact?.AccountingProvider}}. {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.DATA-CAN-ONLY' | translate}} {{this.customer.PrimaryContact?.AccountingProvider}} {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.BE-MODIFIED' | translate}}"></t4-page-warning>
        </div>
      </div>
    }

    @if (this.customer.PrimaryContact?.IsPlaceholder) {
      <div class="row">
        <div class="col-12">
          <t4-page-warning warning="{{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.PLACEHOLDER' | translate}}"></t4-page-warning>
        </div>
      </div>
    }

    <div class="form-layout row">
      <div class="col">
        @if (canDegradeAccountToUnderlying) {
          <div class="row">
            <div class="col">
              <button (click)="degradeAccountToUnderlying()" class="btn btn-block btn-primary bd-0">
                <span>{{ 'GENERIC.BUTTON.DEGRADE' | translate }}</span>
              </button>
            </div>
          </div>
        }


        @if (isCustomerReworkActive) {
          <div class="row">
            <div class="form-group col-12">
              <label class="form-control-label">
                {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CUSTOMERTYPE' | translate }}@if (mainForm.get('CustomerType').hasValidator(requiredValidator)) {
                  <span class="tx-danger">*</span>
                }
              </label>
              <div class="d-flex">
                <div class="form-check me-4">
                  <input class="form-check-input" type="radio" formControlName="CustomerType" [value]="2" id="privateCustomerRadio">
                  <label class="form-check-label" for="privateCustomerRadio">{{ 'FANS.EDIT-CUSTOMER-FORM.COMPONENT.CUSTOMER-DETAILS.CUSTOMER-TYPE.FORM.DROPDOWN.PRIVATE-CUSTOMER' | translate }}</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" formControlName="CustomerType" [value]="1" id="businessCustomerRadio">
                  <label class="form-check-label" for="businessCustomerRadio">{{ 'FANS.EDIT-CUSTOMER-FORM.COMPONENT.CUSTOMER-DETAILS.CUSTOMER-TYPE.FORM.DROPDOWN.BUSINESS-CUSTOMER' | translate }}</label>
                </div>
              </div>
              <t4-display-validation controlName="CustomerType" [form]="mainForm" [messages]="validationMessages">
              </t4-display-validation>
            </div>
          </div>

          @if (isBusinessCustomer) {
            <div class="row">
              <div class="form-group col-12">
                <label class="form-control-label">
                  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.ACCOUNTMANAGER' | translate }}@if (mainForm.get('AccountManagerId').hasValidator(requiredValidator)) {
                    <span class="tx-danger">*</span>
                  }
                </label>
                <ng-select [items]="accountManagers" bindLabel="Name" bindValue="Id" formControlName="AccountManagerId"
                  placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.ACCOUNTMANAGER' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
                </ng-select>
                <t4-display-validation controlName="AccountManagerId" [form]="mainForm" [messages]="validationMessages">
                </t4-display-validation>
              </div>
            </div>

            <app-edit-customer-company-details [mainForm]="mainForm" [showEmail]="showCompanyEmail">
            </app-edit-customer-company-details>
          } @else {
            <app-edit-customer-primary-account [PrimaryContact]="PrimaryContact" [primaryContact]="customer.PrimaryContact" (ssoDeleted)="mainForm.enable(); Address.enable(); updateCompanyEmailState()">
            </app-edit-customer-primary-account>
          }

          <app-edit-customer-address [Address]="Address"></app-edit-customer-address>
        } @else {
          <app-edit-customer-legacy-details [mainForm]="mainForm" [accountManagers]="accountManagers"></app-edit-customer-legacy-details>
        }
      </div>
    </div>

    @if (!isCustomerReworkActive) {
      <div class="form-layout row">
        <app-edit-customer-legacy-address class="col-12 col-lg-6" [Address]="Address"></app-edit-customer-legacy-address>
        <app-edit-customer-legacy-primary-account class="col-12 col-lg-6" [PrimaryContact]="PrimaryContact" [primaryContact]="customer.PrimaryContact" (ssoDeleted)="mainForm.enable(); Address.enable(); updateCompanyEmailState()"></app-edit-customer-legacy-primary-account>
      </div>
    }

<!-- Buttons -->
<div class="row">

  <div class="col-6">
    <button (click)="submit()" [disabled]="!customerIsValidAndDirty()" class="btn btn-block btn-primary bd-0">
      <i class="far fa-save"></i>
      <span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span>
    </button>
  </div>
  <div class="col-6">
    <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0">
      <i class="fas fa-ban"></i>
      <span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
</div>
</form>
